<!-- Footer Copyright 2022 Rebecca L Beaudet -->
<script>
  import { CORP_NAME, STANDARD_HOURS } from '../language/constantContent';
  import { Link } from 'svelte-routing';
</script>

<footer class="container mt-4">
  <hr />
  <div class="d-flex justify-content-between">
    <div>
      <span>{`© Copyright 2022 `}</span>
      <p>{CORP_NAME}</p>
    </div>
    <!-- <div>
      <span>{`Operating hours `}</span>
      <p>{STANDARD_HOURS}</p>
    </div> -->
    <Link class="btn btn-secondary" type="button" to="/">Home</Link>
  </div>
</footer>
